import { appUrl, hidePricing, locations, selectedLocation } from "../../utils/variables";

export function loadConsultDetail(provider, procedures, average_total) {
    const locationId = selectedLocation || provider.location_ids[0];
    const locationsFiltered = locations.filter(location => location.id === locationId);

    const wrapper = document.querySelector(
        '.consultSummary__container .content__wrapper'
    );
    wrapper.innerHTML = '';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    wrapper.insertAdjacentHTML(
        'beforeend',
        `
        <div class="provider__wrapper">
            <img class="provider__avt" src="${provider?.photo ? provider.photo : `${appUrl}/assets/images/png/default-avatar.png`}" >
            <div class="provider__info">
                <div class="provider__name">${provider?.first_name || ''} ${provider?.last_name || ''
        }</div>
                <div class="provider__title">${provider?.title || ''}</div>
            </div>
        </div>
        <div class="consult__card">
            <i class="ri-time-line"></i>
            <div class="consult__info">
                <div class="consult__title">Total</div>
               ${provider.consult_price_from === provider.consult_price_to ||
            provider.consult_price_to === null
            ? `
                    <div class="consult__content">${provider.consult_price_from !== null
                ? formatter.format(provider.consult_price_from)
                : 'Free'
            } ${provider.consult_duration_in_minutes ? `(${provider.consult_duration_in_minutes} minutes)` : ''}</div>`
            : `<div class="consult__content">${formatter.format(
                provider.consult_price_from
            )} ~ ${formatter.format(provider.consult_price_to)} (${provider.consult_duration_in_minutes
            } minutes)</div>`
        } 
                ${provider.consult_fee_applied_to_service
            ? `<div class="consult__note">Consult fee is applied to service costs</div>`
            : ''
        }
            </div>
        </div>  
        <div class="consult__card">
            <i class="ri-file-list-2-line"></i>
            <div class="consult__info">
                <div class="consult__title">Services</div>
                <div class="consult__procedures">
                    ${loadListProcedures(procedures)}
                </div>
            </div>
        </div>
        <div class="consult__card">
            <i class="ri-map-pin-line"></i>
            <div class="consult__info">
                <div class="consult__title">Location</div>
                <div class="consult__content">${locationsFiltered[0]?.name ?? '—'}</div>
            </div>
        </div>
    `
    );
}

function loadListProcedures(procedures) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    const listProcedures = Array.isArray(procedures) ? procedures : (procedures ? [procedures] : []);
    const validProcedures = listProcedures.filter((p) => p != null && typeof p === 'object');
    let list = '';
    for (const procedure of validProcedures) {
        list = list.concat(`
        <div class="consult__content"> ${procedure?.name ?? ''}</div>
        ${hidePricing
                ? ''
                : `
            ${procedure?.min_cost === procedure?.max_cost ||
                    procedure?.max_cost === null
                    ? `
                <div class="consult__note">${procedure?.min_cost
                        ? formatter.format(procedure.min_cost)
                        : ''
                    }</div>`
                    : `<div class="consult__note">${procedure?.min_cost
                        ? `
                    ${formatter.format(
                            procedure.min_cost
                        )} ~ ${formatter.format(procedure.max_cost)}
                    `
                        : ''
                    }</div>`
                } 
            `
            }
        `);
    }
    return list;
}
